"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = _styledComponents.default.ul.withConfig({
  displayName: "Legend__List",
  componentId: "sc-11hmhrh-0"
})(["padding:0;margin:4px 0 0 0;list-style-type:none;", ""], function (_ref) {
  var horizontal = _ref.horizontal;
  return horizontal && "\n    display: flex;\n    flex-wrap: wrap;\n    & > * { margin-right: 10px; }\n  ";
});

var ListItem = _styledComponents.default.li.withConfig({
  displayName: "Legend__ListItem",
  componentId: "sc-11hmhrh-1"
})(["display:flex;flex-direction:row;align-items:center;list-style-type:none;flex-wrap:nowrap;width:", ";& > *{margin-right:8px;}& >:nth-child(2){flex:1 0;min-width:50px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;}"], function (_ref2) {
  var horizontal = _ref2.horizontal;
  return horizontal ? 'auto' : '100%';
});

var ColorPreviewCircle = _styledComponents.default.div.withConfig({
  displayName: "Legend__ColorPreviewCircle",
  componentId: "sc-11hmhrh-2"
})(["background-color:", ";border-radius:50%;width:8px;height:8px;"], function (_ref3) {
  var color = _ref3.color;
  return color;
});

var Text = _styledComponents.default.span.withConfig({
  displayName: "Legend__Text",
  componentId: "sc-11hmhrh-3"
})(["font-family:", ";font-weight:500;font-size:13px;line-height:21px;color:", ";opacity:1.0;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.font1;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.one[0];
});

var MAX_ITEMS = 6;

var Legend = function Legend(_ref6) {
  var data = _ref6.data,
      horizontal = _ref6.horizontal;
  var truncateElement;

  if (data.length > MAX_ITEMS) {
    truncateElement = /*#__PURE__*/_react.default.createElement(ListItem, {
      key: "-1"
    }, /*#__PURE__*/_react.default.createElement(Text, {
      variant: "small",
      weight: "light"
    }, "..."));
  }

  var displayedData = horizontal ? data : data.slice(0, MAX_ITEMS);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(List, {
    horizontal: horizontal
  }, displayedData.map(function (node, i) {
    return /*#__PURE__*/_react.default.createElement(ListItem, {
      key: i,
      horizontal: horizontal
    }, /*#__PURE__*/_react.default.createElement(ColorPreviewCircle, {
      color: node.fill
    }), /*#__PURE__*/_react.default.createElement(Text, {
      variant: "small",
      weight: "light"
    }, node.label));
  }), !horizontal && truncateElement));
};

Legend.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
    fill: _propTypes.default.string.isRequired
  })).isRequired,
  horizontal: _propTypes.default.bool
};
Legend.defaultProps = {
  horizontal: false
};
var _default = Legend;
exports.default = _default;
//# sourceMappingURL=Legend.js.map